import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./utils/chartTypography";
import { Provider } from "react-redux";
import store from "./store"; // Make sure you have a store.js file exporting your Redux store
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// blocks wheel‑driven increments on every <input type="number">
function stopNumberScroll(e) {
  const el = document.activeElement; // the field that has focus
  if (el && el.type === "number" && e.target === el) {
    e.preventDefault(); // stop the wheel event
    el.blur(); // optional: also drop focus
  }
}

window.addEventListener("wheel", stopNumberScroll, { passive: false });

// NTSW credentials used to be cached in the browser; remove any stored copy.
try {
  localStorage.removeItem("nts_username");
  localStorage.removeItem("nts_password");
} catch (e) {
  // storage unavailable (private mode, blocked site data)
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
serviceWorkerRegistration.unregister();
